<template>
    <div
        :id="'action-list-' + numb"
        class="absolute z-[99999999] mt-[20px] opacity-0 transition-opacity duration-300"
    >
        <ul
            ref="rootEl"
            class="relative w-[230px] overflow-visible rounded-[6.5px] border border-[#E5E7EB] bg-white p-[5px] shadow-lg focus:outline-hidden"
        >
            <li v-if="depth === 0" class="mb-[5px]">
                <div class="flex items-center gap-[10px] px-[11px] py-[5px]">
                    <div
                        class="h-[18px] w-[18px] shrink-0 overflow-hidden rounded-full ring-[1px] ring-[#E5E7EB]"
                    >
                        <img
                            :src="resolvedProfilePhoto"
                            class="h-full w-full object-cover"
                            alt="Profile photo"
                        />
                    </div>

                    <div class="min-w-0">
                        <span
                            class="block truncate text-[12.25px] font-semibold leading-[17.395px] text-[#4B5563]"
                        >
                            {{ resolvedUserName }}
                        </span>
                    </div>
                </div>
            </li>

            <template v-for="(node, index) in nodes" :key="index">
                <li v-if="depth === 0 && index === 0" class="h-[28px]">
                    <div
                        role="button"
                        class="group relative flex h-[28px] cursor-pointer select-none items-center justify-between rounded-[3.5px] px-[11px] text-[12.25px] font-normal leading-[17.395px] text-[#4B5563] hover:bg-gray-100 focus:outline-hidden"
                        :class="{
                            'hover:bg-custom-red-100 hover:text-custom-red-600':
                                node.danger,
                            'bg-gray-100 text-gray-700':
                                !!node.children && isExpanded(node),
                        }"
                        @click.stop="clickNode(node)"
                    >
                        <span class="truncate">{{ node.name }}</span>
                    </div>
                </li>

                <li
                    v-if="depth === 0 && index === 1"
                    class="my-[5px] border-t border-[#E5E7EB]"
                    aria-hidden="true"
                />

                <li v-if="depth === 0 && index === 1" class="h-[40px]">
                    <div
                        ref="teamRowEl"
                        role="button"
                        class="group relative flex h-[40px] cursor-pointer select-none items-center justify-between rounded-[3.5px] px-[11px] hover:bg-gray-100"
                        @click.stop="toggleTeamsPanel"
                    >
                        <div class="flex min-w-0 items-center gap-[10px]">
                            <div
                                class="h-[18px] w-[18px] shrink-0 overflow-hidden rounded-full"
                            >
                                <img
                                    :src="resolvedTeamPhoto"
                                    class="h-full w-full object-cover"
                                    alt="Team photo"
                                />
                            </div>

                            <div class="min-w-0">
                                <div
                                    class="truncate text-[12.25px] font-medium leading-[17.395px] text-[#4B5563]"
                                >
                                    {{ resolvedTeamName }}
                                </div>
                                <div
                                    class="truncate text-[12.25px] font-medium leading-[12.78px] text-[#9FA6B2]"
                                >
                                    ID: {{ resolvedTeamId }}
                                </div>
                            </div>
                        </div>

                        <div
                            class="ml-[10px] flex h-[18px] w-[18px] items-center justify-center text-[#4B5563]"
                        >
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11 8.5L14.4645 11.9645L11 15.4289"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </div>
                </li>

                <li
                    v-if="
                        !(depth === 0 && index === 0) &&
                        !(depth === 0 && index === nodes.length - 1)
                    "
                    class="h-[28px]"
                >
                    <div
                        role="button"
                        class="group relative flex h-[28px] cursor-pointer select-none items-center justify-between rounded-[3.5px] px-[11px] text-[12.25px] font-normal leading-[17.395px] text-[#4B5563] hover:bg-gray-100 focus:outline-hidden"
                        :class="{
                            'hover:bg-custom-red-100 hover:text-custom-red-600':
                                node.danger,
                            'bg-gray-100 text-gray-700':
                                !!node.children && isExpanded(node),
                        }"
                        @click.stop="clickNode(node)"
                    >
                        <span class="truncate">{{ node.name }}</span>

                        <span v-if="node.isChecked">
                            <CheckIcon class="mr-2 h-4 w-4" />
                        </span>

                        <div
                            v-if="node.icon"
                            class="cursor-pointer text-gray-400 group-hover:text-gray-500"
                        >
                            <component :is="node.icon" class="h-6 w-6" />
                        </div>

                        <div
                            v-show="node.children"
                            class="text-gray-400 group-hover:text-gray-700"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M11 8.5L14.4645 11.9645L11 15.4289"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                    </div>

                    <!--                    <ActionList-->
                    <!--                        v-if="isOpen"-->
                    <!--                        :nodes="items"-->
                    <!--                        @node-clicked="nodeWasClicked"-->
                    <!--                        @open-create-team-modal="openCreateTeamModal"-->
                    <!--                        @click.stop-->
                    <!--                    />-->
                </li>

                <li
                    v-if="depth === 0 && index === nodes.length - 1"
                    class="my-[5px] border-t border-[#E5E7EB]"
                    aria-hidden="true"
                />

                <li
                    v-if="depth === 0 && index === nodes.length - 1"
                    class="h-[28px]"
                >
                    <div
                        role="button"
                        class="group relative flex h-[28px] cursor-pointer select-none items-center justify-between rounded-[3.5px] px-[11px] text-[12.25px] font-normal leading-[17.395px] text-[#4B5563] hover:bg-gray-100 focus:outline-hidden"
                        :class="{
                            'hover:bg-custom-red-100 hover:text-custom-red-600':
                                node.danger,
                        }"
                        @click.stop="clickNode(node)"
                    >
                        <span class="truncate">{{ node.name }}</span>
                    </div>
                </li>
            </template>

            <ul
                v-if="depth === 0 && teamsPanelOpen"
                class="absolute right-[calc(100%+8px)] z-[99999999] w-[200px] overflow-visible rounded-[6.5px] border border-[#E5E7EB] bg-white p-[5px] shadow-lg focus:outline-hidden"
                :style="{ top: teamsPanelTop + 'px' }"
            >
                <li class="h-[28px]">
                    <div
                        role="button"
                        class="flex h-[28px] cursor-pointer select-none items-center rounded-[3.5px] px-[11px] text-[12.25px] font-medium leading-[17.395px] text-[#2563EB] hover:bg-gray-100 focus:outline-hidden"
                        @click.stop="goAllTeams"
                    >
                        {{ $t("vue.all_accounts") }}
                    </div>
                </li>

                <template v-if="submenuTeams.length">
                    <li
                        class="my-[5px] border-b border-[#E5E7EB]"
                        aria-hidden="true"
                    />

                    <li
                        v-for="(t, tIndex) in submenuTeams"
                        :key="t.id ?? tIndex"
                        class="h-[28px]"
                    >
                        <div
                            role="button"
                            class="group relative flex h-[28px] cursor-pointer select-none items-center justify-between rounded-[3.5px] px-[11px] text-[12.25px] font-normal leading-[17.395px] text-[#4B5563] hover:bg-gray-100 focus:outline-hidden"
                            @click.stop="switchTeamFromSubmenu(t.id)"
                        >
                            <span class="truncate">{{ t.name }}</span>
                            <span
                                v-if="t.id !== teamProps.id"
                                class="ml-2 shrink-0 text-[#9FA6B2]"
                            >
                                {{ t.id }}
                            </span>
                            <span v-else class="ml-2 shrink-0 text-[#9FA6B2]">
                                {{ $t("vue.current_team") }}
                            </span>
                        </div>
                    </li>
                </template>

                <li
                    class="my-[5px] border-t border-[#E5E7EB]"
                    aria-hidden="true"
                />
                <li class="px-[11px] px-[10px]">
                    <AtomicButton
                        color="yellow"
                        type="button"
                        class="w-full box-border !h-[28px] !rounded-[6px] !px-[14px] !py-0 !justify-center !gap-[3.652px] !leading-[28px]"
                        @click="
                            checkAccessOrShowModal() && handleCreateTeamModal()
                        "
                    >
                        <template #icon>
                            <div
                                class="mr-0 flex h-[10px] w-[10px] items-center justify-center"
                            >
                                <svg
                                    width="10"
                                    height="10"
                                    viewBox="0 0 10 10"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5 1V9M1 5H9"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                    />
                                </svg>
                            </div>
                        </template>
                        {{ $t("vue.create_new_account") }}
                    </AtomicButton>
                </li>
            </ul>

            <div
                :id="'supportBox' + numb"
                class="absolute left-0 top-1/2 z-[-1] h-[calc(100%+40px)] w-[calc(100%+20px)] -translate-y-1/2 transform cursor-default"
            />
        </ul>
    </div>
</template>

<script lang="ts" setup>
import {
    ref,
    type PropType,
    onMounted,
    onBeforeUnmount,
    computed,
    nextTick,
} from "vue";
import type IActionNode from "@/types/Atomic/IActions";
import { CheckIcon } from "@heroicons/vue/24/outline";
import { uuid } from "vue-uuid";
import { usePage } from "@inertiajs/vue3";
import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import type IUser from "@/types/Members/IUser";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import useTeamMemberAccess from "@/composables/useTeamMemberAccess.ts";

const page = usePage<IRhizomPageProps>();

const globalProps = computed(() => usePage<IRhizomPageProps>().props);
const teamProps = computed(() => globalProps.value.team as ICurrentTeam);
const userProps = computed(() => globalProps.value.user as IUser);

const teamExpanded = ref(false);

const resolvedProfilePhoto = computed(
    () => userProps.value?.profile_photo_url ?? "",
);
const resolvedTeamPhoto = computed(
    () => teamProps.value?.profile_photo_url ?? "",
);
const resolvedUserName = computed(() => userProps.value?.name ?? "");
const resolvedTeamName = computed(() => (teamProps.value as any)?.name ?? "");
const resolvedTeamId = computed(() => (teamProps.value as any)?.id ?? "");

const props = defineProps({
    nodes: {
        type: Array as PropType<IActionNode[]>,
        required: true,
    },
    depth: {
        type: Number,
        default: 0,
    },
    userTeams: {
        type: Array as PropType<Array<{ id: number | string; name: string }>>,
        default: () => [],
    },
});

/* TEAMS HANDLERS START*/

const { checkAccessOrShowModal } = useTeamMemberAccess();

const createTeamModal = ref(false);

const handleCreateTeamModal = () => {
    if (!checkAccessOrShowModal()) return;

    teamsPanelOpen.value = false;
    emit("open-create-team-modal");
    fetchTeams();
};

const teamsPanelOpen = ref(false);
const teamsPanelTop = ref(80);

type ElementTemplateRef = HTMLElement | HTMLElement[] | null;

const rootEl = ref<ElementTemplateRef>(null);
const teamRowEl = ref<ElementTemplateRef>(null);

const resolveElement = (value: ElementTemplateRef): HTMLElement | null => {
    if (value instanceof HTMLElement) return value;
    if (Array.isArray(value)) {
        return value.find((item) => item instanceof HTMLElement) ?? null;
    }

    return null;
};

const toggleTeamsPanel = async () => {
    const opening = !teamsPanelOpen.value;

    if (!opening) {
        teamsPanelOpen.value = false;
        teamsPanelTop.value = 80; // reset default
        return;
    }

    teamsPanelOpen.value = true;

    if (
        !props.userTeams?.length &&
        (!allTeams.value || !allTeams.value.length)
    ) {
        await fetchTeams();
    }

    await nextTick();

    const root = resolveElement(rootEl.value);
    const row = resolveElement(teamRowEl.value);

    if (!root || !row) {
        teamsPanelTop.value = 80;
        return;
    }

    // ✅ stabilní výpočet topu: rowTop - rootTop
    const rootRect = root.getBoundingClientRect();
    const rowRect = row.getBoundingClientRect();

    teamsPanelTop.value = Math.max(0, Math.round(rowRect.top - rootRect.top));
};

const goAllTeams = () => {
    window.location.href = route("teams.index");
};

const clickUserTeam = (t: { id: number | string; name: string }) => {
    emit("user-team-clicked", t);
};

const { fetchTeams, getCurrentTeamMembersCount, allTeams } =
    useTeamsAndMembers();

const submenuTeams = computed(() => {
    if (props.userTeams?.length) return props.userTeams;

    return (allTeams.value ?? []).map((t: any) => ({
        id: t.id,
        name: t.name,
    }));
});

const form = ref<{ id: number }>({ id: 0 });

const switchTeam = (teamId: number) => {
    if (teamProps.value.id === teamId) {
        teamsPanelOpen.value = false;
        return;
    }

    form.value.id = teamId;

    router.post(route("teams.switch.store"), form.value, {
        onSuccess: () => {
            teamsPanelOpen.value = false;
            getCurrentTeamMembersCount();
            fetchTeams();
            window.location.reload();
        },
    });
};

const switchTeamFromSubmenu = (teamId: number | string) => {
    const idNum = typeof teamId === "string" ? Number(teamId) : teamId;
    if (!Number.isFinite(idNum)) return;
    switchTeam(idNum);
};

/* TEAMS HANDLERS END*/

const emit = defineEmits([
    "node-clicked",
    "user-team-clicked",
    "open-create-team-modal",
]);

const element = ref<HTMLElement | null>(null);
const expanded = ref<IActionNode[]>([]);
const targetIsVisible = ref(false);
const numb = uuid.v4();

onMounted(() => {
    setElementPosition();
    setSupportBoxPosition();
});

onBeforeUnmount(() => {
    if (element.value) {
        element.value.classList.replace("opacity-100", "opacity-0");
    }
});

const setElementPosition = () => {
    element.value = document.querySelector("#action-list-" + numb);

    if (element.value) {
        const bounding = element.value.getBoundingClientRect();

        setElementPositionHorizontally(bounding);
        setElementPositionVertically(bounding);

        element.value.classList.replace("opacity-0", "opacity-100");
    }
};

const setElementPositionHorizontally = (bounding: DOMRect) => {
    if (element.value) {
        if (
            bounding.right + bounding.width >
            (window.innerWidth || document.documentElement.clientWidth)
        ) {
            targetIsVisible.value = true;
            if (props.depth === 0) {
                element.value.classList.add("right-0");
            } else {
                element.value.classList.add("left-[-171px]");
            }
        } else {
            if (props.depth === 0) {
                element.value.classList.add("left-0");
            } else {
                element.value.classList.add("right-[-171px]");
            }
        }
    }
};

const setElementPositionVertically = (bounding: DOMRect) => {
    if (element.value) {
        if (
            bounding.top > bounding.height + 64 &&
            bounding.top + bounding.height >
                (window.innerHeight || document.documentElement.clientHeight)
        ) {
            targetIsVisible.value = true;

            if (props.depth === 0) {
                element.value.classList.add("bottom-[calc(100%+4px)]");
            } else {
                element.value.classList.add("bottom-0", "mb-1");
            }
        } else {
            element.value.classList.add("origin-top-right", "mt-1");
        }
    }
};

const setSupportBoxPosition = () => {
    const supportBox = document.querySelector("#supportBox" + numb);

    if (!supportBox) {
        return;
    }

    if (targetIsVisible.value) {
        supportBox.classList.replace("left-0", "right-0");
    }
    if (props.depth === 0) {
        supportBox.classList.remove("w-[calc(100%+20px)]", "left-0", "right-0");
        supportBox.classList.add(
            "w-[calc(100%+40px)]",
            "-translate-x-1/2",
            "left-1/2",
        );
    }
};

const isExpanded = (node: IActionNode) => {
    return expanded.value.indexOf(node) !== -1;
};

const nodeHovered = (node: IActionNode) => {
    if (!isExpanded(node)) {
        expanded.value.splice(0, 1, node);
    } else {
        expanded.value.splice(expanded.value.indexOf(node));
    }
};
const clickNode = (node: IActionNode) => {
    if (node.children === undefined) {
        emit("node-clicked", node);
    }
};
</script>
